import React from 'react';

import { StyleSheet } from 'react-native';

import { MarketingBasicTile } from 'components/marketing-basic-tile';
import { Box, BoxProps } from 'components/ui';
import { useIsDesktopBreakpoint } from 'hooks/use-media-query';
import { getDesignToken, primitive, spacing } from 'styles/constants';
import { LayoutWidth } from 'styles/constants/enums';

export const Section = ({ style, ...props }: BoxProps) => {
  const isDesktop = useIsDesktopBreakpoint();
  return React.createElement(Box, {
    ...props,
    style: [styles.section, isDesktop && styles.sectionDesktop, style],
  });
};

export const LeftContainer = ({ style, ...props }: BoxProps) => {
  const isDesktop = useIsDesktopBreakpoint();
  return React.createElement(Box, {
    ...props,
    style: [styles.sideContainer, isDesktop && styles.leftDesktop, style],
  });
};

export const RightContainer = ({ style, ...props }: BoxProps) => {
  const isDesktop = useIsDesktopBreakpoint();
  return React.createElement(Box, {
    ...props,
    style: [styles.sideContainer, isDesktop && styles.rightDesktop, style],
  });
};

export const QuadTileContainer = ({ style, ...props }: BoxProps) => {
  const isDesktop = useIsDesktopBreakpoint();
  return React.createElement(Box, {
    ...props,
    style: [styles.quadTileContainer, isDesktop && styles.quadTileContainerDesktop, style],
  });
};

export const StyledBasicTile = MarketingBasicTile.withConfig<{ newUI?: boolean }>(p => ({
  background: p.newUI ? null : primitive.$mayoEggWhite,
  flexDirection: 'row',
  padding: '$4',
  margin: '$4',
  borderRadius: 'md',
  shadow: p.newUI ? '0px' : '2px',
  borderWidth: p.newUI ? '1' : null,
  borderColor: p.newUI ? primitive.$greyFive : null,
  _basicTileTitle: {
    color: getDesignToken('alert-info-background'),
    fontSize: 'sm',
    lineHeight: '2xs',
    textAlign: 'left',
  },
  _typographyBlock: {
    color: primitive.$bbqBrown,
    fontFamily: 'heading',
    fontSize: 'sm',
    lineHeight: '2xs',
  },
  _basicTileImage: {
    height: 'full',
    marginTop: 'auto',
    marginBottom: 'auto',
    marginLeft: '$0',
    marginRight: '$1',
    maxHeight: '50px',
    maxWidth: '50px',
  },
}));

const styles = StyleSheet.create({
  section: {
    alignSelf: 'center',
    flexBasis: 'auto',
    flexGrow: 1,
    flexShrink: 1,
    justifyContent: 'center',
    marginBottom: spacing.$4,
    marginHorizontal: 'auto',
    marginTop: spacing.$4,
    paddingHorizontal: spacing.$3,
    width: '100%',
  },
  sectionDesktop: {
    marginHorizontal: spacing.$6,
    marginTop: 0,
    maxWidth: LayoutWidth.REGULAR,
    paddingHorizontal: 0,
  },
  sideContainer: {
    flexDirection: 'row',
  },
  leftDesktop: {
    flex: 1,
    paddingRight: spacing.$2,
  },
  rightDesktop: {
    flex: 1,
    paddingLeft: spacing.$2,
  },
  quadTileContainer: {
    justifyContent: 'center',
  },
  quadTileContainerDesktop: {
    maxWidth: 800,
  },
});
